import React, { useEffect } from "react";
import {
  ChakraProps,
  FormControl,
  FormErrorMessage,
  FormLabel,
  Input,
} from "@chakra-ui/react";
import { useField } from "formik";
import { InputHTMLAttributes } from "react";
import { formatNumber } from "../../utils/formatNumber";
import { useFocus } from "../../hooks/useFocus";

type InputNumberProps = InputHTMLAttributes<HTMLInputElement> &
  ChakraProps & {
    name: string;
    label?: string;
    decimalPlaces?: number;
    onChangeVal?: (item: number) => void;
    focus?: boolean;
    labelChildren?: () => React.ReactNode;
  };

const InputNumber: React.FC<InputNumberProps> = ({
  label,
  decimalPlaces,
  size: _,
  width,
  focus = false,
  onChangeVal,
  labelChildren,
  ...props
}) => {
  const [field, { error }, { setValue }] = useField(props);

  const [inputRef, setInputFocus] = useFocus();

  useEffect(() => {
    if (focus) {
      (setInputFocus as any)();
    }
  }, [focus, setInputFocus])

  const decPlaces = typeof decimalPlaces === "number" ? decimalPlaces : 2;
  const handleNumberChange = (e: any) => {
    const value =
      "0".repeat(decPlaces + 1) + e.target.value.replace(/[^0-9]/g, "");
    const val =
      value.substring(0, value.length - decPlaces) +
      "." +
      value.substring(value.length - decPlaces);
    setValue(parseFloat(val), false);
    typeof onChangeVal === 'function' && onChangeVal(parseFloat(val));
  };

  return (
    <FormControl width={width} isInvalid={!!error} p={1}>
      {!!label && <FormLabel mt={2} mb={0} htmlFor={field.name}>{label} {typeof labelChildren === 'function' && labelChildren()} </FormLabel>}
      <Input
        bg={'white'}
        color={'black'}
        value={formatNumber(field.value, decPlaces, true)}
        onBlur={field.onBlur}
        onChange={handleNumberChange}
        id={field.name}
        {...props}
        placeholder={props.placeholder}
        borderRadius={2}
        ref={inputRef}
      />
      {error && <FormErrorMessage>{error}</FormErrorMessage>}
    </FormControl>
  );
};

export default InputNumber;
